export enum PUBSUB_TOPICS {
  GRAPH_HAVE_ERROR = 'GRAPH_HAVE_ERROR',
}
